const cryptoIconPath = (symbol) =>
  require(`../../../node_modules/cryptocurrency-icons/svg/color/${symbol.toLowerCase()}.svg`);

export const currencyOptions = [
  {
    value: "USD",
    label: "USD - United States Dollar",
    flag: "https://flagcdn.com/us.svg",
  },
  {
    value: "JPY",
    label: "JPY - Japanese Yen",
    flag: "https://flagcdn.com/jp.svg",
  },
  { value: "EUR", label: "EUR - Euro", flag: "https://flagcdn.com/eu.svg" },
  {
    value: "GBP",
    label: "GBP - British Pound",
    flag: "https://flagcdn.com/gb.svg",
  },
  {
    value: "AUD",
    label: "AUD - Australian Dollar",
    flag: "https://flagcdn.com/au.svg",
  },
  {
    value: "CAD",
    label: "CAD - Canadian Dollar",
    flag: "https://flagcdn.com/ca.svg",
  },
  {
    value: "CHF",
    label: "CHF - Swiss Franc",
    flag: "https://flagcdn.com/ch.svg",
  },
  {
    value: "INR",
    label: "INR - Indian Rupee",
    flag: "https://flagcdn.com/in.svg",
  },
  {
    value: "CNY",
    label: "CNY - Chinese Yuan",
    flag: "https://flagcdn.com/cn.svg",
  },
  {
    value: "BRL",
    label: "BRL - Brazilian Real",
    flag: "https://flagcdn.com/br.svg",
  },
  {
    value: "ZAR",
    label: "ZAR - South African Rand",
    flag: "https://flagcdn.com/za.svg",
  },

  {
    value: "KRW",
    label: "KRW - South Korean Won",
    flag: "https://flagcdn.com/kr.svg",
  },
  {
    value: "TRY",
    label: "TRY - Turkish Lira",
    flag: "https://flagcdn.com/tr.svg",
  },
  {
    value: "MXN",
    label: "MXN - Mexican Peso",
    flag: "https://flagcdn.com/mx.svg",
  },
  {
    value: "SAR",
    label: "SAR - Saudi Riyal",
    flag: "https://flagcdn.com/sa.svg",
  },
  {
    value: "SGD",
    label: "SGD - Singapore Dollar",
    flag: "https://flagcdn.com/sg.svg",
  },
  {
    value: "HKD",
    label: "HKD - Hong Kong Dollar",
    flag: "https://flagcdn.com/hk.svg",
  },
  {
    value: "NOK",
    label: "NOK - Norwegian Krone",
    flag: "https://flagcdn.com/no.svg",
  },
  {
    value: "SEK",
    label: "SEK - Swedish Krona",
    flag: "https://flagcdn.com/se.svg",
  },
  {
    value: "DKK",
    label: "DKK - Danish Krone",
    flag: "https://flagcdn.com/dk.svg",
  },
  {
    value: "NZD",
    label: "NZD - New Zealand Dollar",
    flag: "https://flagcdn.com/nz.svg",
  },
  {
    value: "AED",
    label: "AED - UAE Dirham",
    flag: "https://flagcdn.com/ae.svg",
  },
  {
    value: "PLN",
    label: "PLN - Polish Zloty",
    flag: "https://flagcdn.com/pl.svg",
  },
  {
    value: "THB",
    label: "THB - Thai Baht",
    flag: "https://flagcdn.com/th.svg",
  },
  {
    value: "MYR",
    label: "MYR - Malaysian Ringgit",
    flag: "https://flagcdn.com/my.svg",
  },
  {
    value: "IDR",
    label: "IDR - Indonesian Rupiah",
    flag: "https://flagcdn.com/id.svg",
  },
  {
    value: "PHP",
    label: "PHP - Philippine Peso",
    flag: "https://flagcdn.com/ph.svg",
  },
  {
    value: "EGP",
    label: "EGP - Egyptian Pound",
    flag: "https://flagcdn.com/eg.svg",
  },
  {
    value: "ILS",
    label: "ILS - Israeli Shekel",
    flag: "https://flagcdn.com/il.svg",
  },
  {
    value: "VND",
    label: "VND - Vietnamese Dong",
    flag: "https://flagcdn.com/vn.svg",
  },
  {
    value: "PKR",
    label: "PKR - Pakistani Rupee",
    flag: "https://flagcdn.com/pk.svg",
  },
  {
    value: "NGN",
    label: "NGN - Nigerian Naira",
    flag: "https://flagcdn.com/ng.svg",
  },
  {
    value: "CLP",
    label: "CLP - Chilean Peso",
    flag: "https://flagcdn.com/cl.svg",
  },
  {
    value: "COP",
    label: "COP - Colombian Peso",
    flag: "https://flagcdn.com/co.svg",
  },
  {
    value: "ARS",
    label: "ARS - Argentine Peso",
    flag: "https://flagcdn.com/ar.svg",
  },
  {
    value: "HUF",
    label: "HUF - Hungarian Forint",
    flag: "https://flagcdn.com/hu.svg",
  },
  {
    value: "CZK",
    label: "CZK - Czech Koruna",
    flag: "https://flagcdn.com/cz.svg",
  },
  {
    value: "RON",
    label: "RON - Romanian Leu",
    flag: "https://flagcdn.com/ro.svg",
  },
  {
    value: "UAH",
    label: "UAH - Ukrainian Hryvnia",
    flag: "https://flagcdn.com/ua.svg",
  },
];

export const crptoOptionsFlag = [
  { value: "BTC", label: "BTC - Bitcoin", flag: cryptoIconPath("btc") },
  { value: "ETH", label: "ETH - Ethereum", flag: cryptoIconPath("eth") },
  { value: "LTC", label: "LTC - Litecoin", flag: cryptoIconPath("ltc") },
  { value: "XRP", label: "XRP - Ripple", flag: cryptoIconPath("xrp") },
  { value: "BCH", label: "BCH - Bitcoin Cash", flag: cryptoIconPath("bch") },
  { value: "DOGE", label: "DOGE - Dogecoin", flag: cryptoIconPath("doge") },
  { value: "ADA", label: "ADA - Cardano", flag: cryptoIconPath("ada") },
  { value: "DOT", label: "DOT - Polkadot", flag: cryptoIconPath("dot") },
  { value: "UNI", label: "UNI - Uniswap", flag: cryptoIconPath("uni") },
  { value: "LINK", label: "LINK - Chainlink", flag: cryptoIconPath("link") },
  { value: "SOL", label: "SOL - Solana", flag: cryptoIconPath("sol") },
  { value: "USDT", label: "USDT - Tether", flag: cryptoIconPath("usdt") },
  { value: "BNB", label: "BNB - Binance Coin", flag: cryptoIconPath("bnb") },
  { value: "USDC", label: "USDC - USD Coin", flag: cryptoIconPath("usdc") },
  { value: "MATIC", label: "MATIC - Polygon", flag: cryptoIconPath("matic") },
  { value: "TRON", label: "TRX - TRON", flag: cryptoIconPath("trx") },
  {
    value: "ETC",
    label: "ETC - Ethereum Classic",
    flag: cryptoIconPath("etc"),
  },
  { value: "FIL", label: "FIL - Filecoin", flag: cryptoIconPath("fil") },
];
